// extracted by mini-css-extract-plugin
module.exports = {"redesignedPersonalFeedback":"styles-module-redesignedPersonalFeedback--_t55Z"};